import { render, staticRenderFns } from "./AccEdit.vue?vue&type=template&id=bb93f554&scoped=true&"
import script from "./AccEdit.vue?vue&type=script&lang=js&"
export * from "./AccEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb93f554",
  null
  
)

export default component.exports